import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';
import isFQDN from 'validator/lib/isFQDN';
import config from '../config';

export {
  isSafeRegex,
  validateSafeRegex,
  validateSafeRegexFragments,
} from './regex';

function validateEmailLocalPart(localPart: string) {
  // Define the allowed characters for the local part of the email
  const localPartPattern = /^[a-zA-Z0-9_\-'.+]+$/;
  // Check if both parts exist and the local part matches the pattern
  if (localPart && localPartPattern.test(localPart)) {
    return true;
  } else {
    return false;
  }
}

export const validateEmail = (value: string) => {
  // Split the email into local part and domain part
  const [localPart] = value.split('@');
  return isEmail(value) && validateEmailLocalPart(localPart);
};

export const validateIsNotEmptyString = (value: string) => {
  return !isEmpty(value);
};

export const validateIsNotWhitespace = (value: string) => {
  return !isEmpty(value.trim());
};

export function isRegExp(value: any) {
  return value instanceof RegExp;
}

export const validateRegExp = (value: string, regExp: RegExp) => {
  return regExp.test(value);
};

export const validateOrgNameLength = (value: string) => {
  return !(value.length > config.ui.globalSettings.limitation.orgNameMaxLength);
};

export const validateHpuName = (value: string) => {
  const HPUNameRegexp = /[|#]/g;
  if (HPUNameRegexp.test(value)) {
    return false;
  }
  return true;
};

export const validatePassword = (password: string) => {
  if (!password) return false;
  if (password.length < 8) return false;
  if (!/[~!@#$%^*\-+=|\\{}[\]:;,.?/]/.test(password)) return false;
  if (!/[0-9]/.test(password)) return false;
  if (!/[a-z]/.test(password)) return false;
  if (!/[A-Z]/.test(password)) return false;
  return true;
};

/**
 *  const domainReg = new RegExp(
 *     /^([a-zA-Z0-9]([-a-zA-Z0-9_]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,13}$/
 *   );
 *   const badDomainReg = /[*()@?:]/;
 *   if (!domainName) return false;
 *   if (domainName.length > 256) return false;
 *   if (badDomainReg.test(domainName)) return false;
 *   if (domainReg.test(domainName)) return true;
 *   return false;
 * @param domainName
 */
export const validateDomain = (domainName: string) => {
  if (domainName.length > 256) return false;
  return isFQDN(domainName);
};
